// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { deserialize_AskGetabstractQuestionAnswers } from "@newgenerated/shared/serializerDeserializer/AskGetabstractQuestionAnswers";

export async function getQuestionAnswers(props: { questionUuid: string }): Promise<ApiResult<schema.AskGetabstractQuestionAnswers>> {
  let path = "/gaapi/search/ask-getabstract/questionAnswers/{questionUuid}";
  path = path.replace(
    "{questionUuid}",
    ((value) => {
      return ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "string");
        return parsed_again;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.questionUuid),
  );
  const response = await gaApiCall({ path: path, method: "GET", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.AskGetabstractQuestionAnswers> => {
    return deserialize_AskGetabstractQuestionAnswers(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
